// extracted by mini-css-extract-plugin
export default {"content":"SelectedRol_content__io7KM","subtitle":"SelectedRol_subtitle__S-vU2","description":"SelectedRol_description__nSv-V","options":"SelectedRol_options__dL29y"};